import React, { useState, useEffect, useRef } from "react";
import Menu from "./Menu";
import Checkout from "./Checkout";
import Header from "./CartHeader";
import CartManagement from "./CartManagement";
import { Grid, CircularProgress, Box } from "@mui/material";
import { headers } from "../../utils/utils";

const Order = () => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const currency = "₹";

  const [checkout, setCheckOut] = useState(false);

  const [currentCategory, setCurrentCategory] = useState("");
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const observerRef = useRef(null);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    if (currentCategory) {
      setPageNumber(0); // Reset page number when category changes
      setProductList([]); // Clear previous products
      itemList(0); // Load first page
    }
  }, [currentCategory]);

  const fetchItemImage = async (itemId) => {
    try {
      const imageResponse = await fetch(
        process.env.REACT_APP_ITEM + `/item/image/${itemId}?limit=All`,
        {
          method: "GET",
          headers: headers(),
        },
      );

      if (imageResponse.ok) {
        let imageList = [];
        const imageBlob = await imageResponse.json();

        if (imageBlob && Array.isArray(imageBlob)) {
          imageBlob.forEach((itmImage) => {
            imageList.push(`data:image/jpeg;base64,${itmImage}`);
          });
        }

        return imageList;
      }
    } catch (err) {
      return "default-image-url";
    }
  };

  const itemList = async (page) => {
    setLoading(true);

    const response = await fetch(
      process.env.REACT_APP_ITEM +
        `/item/index?categoryId=${currentCategory}&pageNumber=${page}&pageSize=12`,
      {
        method: "POST",
        body: JSON.stringify({ categoryId: currentCategory }),
        headers: headers(),
      },
    );

    if (response.ok) {
      const result = await response.json();
      const tax = [
        { name: "CGST", percentage: 9.5 },
        { name: "SGST", percentage: 9.5 },
      ];

      const updatedItems = await Promise.all(
        result.content.map(async (item) => {
          const imageList = await fetchItemImage(item.id);
          return {
            ...item,
            imageList,
            tax,
          };
        }),
      );
      setProductList((prev) => [...prev, ...updatedItems]);
      setLoading(false);
    }
  };

  // Infinite Scroll Observer
  useEffect(() => {
    if (checkout == false) {
      if (loading) return;
      if (!observerRef.current) return;

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setPageNumber((prevPage) => prevPage + 1);
          }
        },
        { threshold: 1.0 },
      );

      observer.observe(observerRef.current);

      return () => observer.disconnect();
    }
  }, [loading]);

  // Load More Items when Page Number Changes
  useEffect(() => {
    if (pageNumber > 0) {
      itemList(pageNumber);
    }
  }, [pageNumber]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={1.7}>
        <Menu
          currentCategory={currentCategory}
          setCurrentCategory={setCurrentCategory}
        />
      </Grid>
      <Grid item xs={10}>
        <br />
        <Header
          cart={cart}
          setCart={setCart}
          checkout={checkout}
          setCheckOut={setCheckOut}
          currency={currency}
        />
        <hr className="hr" />

        {checkout ? (
          <Checkout cart={cart} setCart={setCart} currency={currency} />
        ) : (
          <CartManagement
            cart={cart}
            setCart={setCart}
            productList={productList}
            currentCategory={currentCategory}
            currency={currency}
          />
        )}

        {loading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="10vh"
          >
            <CircularProgress />
          </Box>
        )}

        <div
          ref={observerRef}
          style={{ height: "10px", marginBottom: "20px" }}
        />
      </Grid>
    </Grid>
  );
};

export default Order;
